// Model.js
// -----------------------
// @module Case
define("Ames.DotDigitalTracker.DotDigtalTracker.Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({

        
});
});
